export default __webpack_public_path__ + "static/media/placeholder-dog.24c86f2b.svg";